module.exports = __webpack_public_path__ + "static/media/gift@2x.103cdf73.png";